// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vl-functional-header[data-v-67336e95] {
  margin-bottom: 0;
}
.vl-functional-header__actions[data-v-67336e95] {
  display: block;
}
.vl-functional-header__container[data-v-67336e95] {
  padding-left: 1.3rem;
}
.vl-functional-header[data-v-67336e95] {
  min-height: 0;
}
.vl-functional-header__sub__actions[data-v-67336e95] {
  padding-top: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
